import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/lib/store";
import { fetchSubsDashboardStats, setDashboardTimeRange, clearError, clearStats } from "./dashboard.slice";
import type { SubsDashboardTimeRange } from "./dashboard.api";

export const useSubsDashboard = () => {
  const dispatch = useAppDispatch();
  const dashboardState = useAppSelector((state) => state.subsDashboard);
  const { stats, dashboardTimeRange, loading, error, lastUpdated } = dashboardState || {
    stats: null,
    dashboardTimeRange: "30d" as SubsDashboardTimeRange,
    loading: false,
    error: null,
    lastUpdated: null,
  };

  // Load dashboard stats on mount
  useEffect(() => {
    dispatch(fetchSubsDashboardStats(undefined));
  }, [dispatch]);

  // Auto-refresh every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchSubsDashboardStats(undefined));
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, [dispatch]);

  const refreshStats = useCallback(() => {
    dispatch(fetchSubsDashboardStats(undefined));
  }, [dispatch]);

  const setTimeRange = useCallback(
    (range: SubsDashboardTimeRange) => {
      dispatch(setDashboardTimeRange(range));
      dispatch(fetchSubsDashboardStats(range));
    },
    [dispatch]
  );

  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleClearStats = useCallback(() => {
    dispatch(clearStats());
  }, [dispatch]);

  return {
    stats,
    dashboardTimeRange,
    setDashboardTimeRange: setTimeRange,
    loading,
    error,
    lastUpdated,
    refreshStats,
    clearError: handleClearError,
    clearStats: handleClearStats,
  };
};



